export default "__VITE_ASSET__BvPAq3i4__"